import { DoctorPicker } from 'views/pickers';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import some from 'lodash/some';
import { withRouter } from 'react-router-dom';
import {
    Checkbox,
    DateSelect,
    FormGroup,
    Input
} from 'mol-ui';
import {
    Col,
    Message,
    Row
} from './styled';
import {
    ConfirmFooter,
    ErrorMessage,
    FormLayout
} from 'views/components';
import React, {
    Fragment,
    useEffect,
    useState
} from 'react';
import {
    dateToObject,
    objectToDate,
    uppercaseFirst
} from 'shared/utils';
import {
    useCheckbox,
    useInput
} from 'hooks';

const VideoconferenceRegistration = ({
    createVideoconference,
    deleteVideoconference,
    editVideoconference,
    getVideoconference,
    history: { push },
    location: { pathname },
    setVideoconferenceVideoconference,
    status,
    videoconference
}) => {

    const [chatCheck, privateChat, setPrivateChat] = useCheckbox(false);
    const [commentInput, comment, setComment] = useInput('');
    const [dateInput, date, setDate] = useInput(dateToObject(moment()));
    const [durationInput, duration, setDuration] = useInput('', { type: 'number' });
    const [errors, setErrors] = useState({});
    const [id, setId] = useState();
    const [prevVideoconference, setPrevVideoconference] = useState({});
    const [timeInput, time, setTime] = useInput('');
    const [mode, setMode] = useState('ver');
    const [publicCheck, publicValue, setPublicValue] = useCheckbox(true);
    const [speakerId, setSpeakerId] = useState(null);
    const [videoStatus, setVideoStatus] = useState('initial');

    useEffect(() => {
        const pathMode = pathname.split('/')[2];
        setMode(pathMode);
        if (['ver', 'editar'].includes(pathMode)) {
            const pathId = pathname.split('/')[3];
            setId(pathId);
            getVideoconference(pathId);
        }
    }, [getVideoconference, pathname]);

    if (!isEmpty(videoconference) && (isEmpty(prevVideoconference) || prevVideoconference.id !== videoconference.id)) {
        setPrevVideoconference(videoconference);
        setComment(videoconference.comment);
        setDate(dateToObject(moment(videoconference.date)));
        setDuration(videoconference.estimated_duration || '');
        setTime(moment(videoconference.date).format('HH:mm'));
        setPrivateChat(!!videoconference.private_chat);
        setPublicValue(!!videoconference.public);
        setSpeakerId(videoconference.speaker.id);
        setVideoStatus(videoconference.status);
    }

    const handleConfirm = () => {
        if (mode === 'ver') {
            push('/videoconferencia/listar');
        } else {
            const data = {
                comment,
                private_chat: privateChat,
                public: publicValue,
                speaker_doctor_id: speakerId,
                start_date_time: `${ objectToDate(date).format('YYYY-MM-DD') } ${ time }`,
                ...(!!duration && { estimated_duration: duration })
            };
            mode === 'crear' ? createVideoconference(data) : editVideoconference({ data, id });
        }
        setVideoconferenceVideoconference({});
    };

    const handleDelete = () => {
        if (mode === 'editar') {
            deleteVideoconference(id);
        }
        setVideoconferenceVideoconference({});
    };

    const validate = () => {
        const result = {
            comment: !comment ? 'Requerido' : undefined,
            duration: !!duration && duration < 0 ? 'Duración inválida' : undefined,
            speaker: !speakerId ? 'Requerido' : undefined,
            time: !time ? 'Requerido' : undefined
        };
        setErrors(result);
        return !some(result);
    };

    const disabled = mode === 'ver';
    const editMode = mode === 'editar';
    const { speaker } = videoconference;
    const speakerName = speaker ? `${ speaker.last_name }, ${ speaker.first_name }` : '';
    return (
        <FormLayout goBackTo="/videoconferencia/listar" title={ `${ uppercaseFirst(mode) } videoconferencia` }>
            {
                status === 'loading'
                    ? <Message>
                        Cargando videoconferencia...
                    </Message>
                    : (editMode && videoStatus === 'finalized')
                        ? <Message>
                            No puedes editar una videoconferencia que ya terminó.
                        </Message>
                        : <Fragment>
                            {
                                !disabled
                                    ? <Fragment>
                                        <Row>
                                            <Col xs="6">
                                                <FormGroup>
                                                    <DoctorPicker
                                                        allowNone={ false }
                                                        margin="0px 0px 20px 0px"
                                                        value={ speakerId }
                                                        onChange={ setSpeakerId }
                                                    />
                                                    <ErrorMessage error={ errors.speaker } relative={ true } />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm="6">
                                                <FormGroup label="Fecha">
                                                    <DateSelect disabled={ disabled } margin="0px 0px 20px 0px" nextYears={ 4 } { ...dateInput } />
                                                </FormGroup>
                                            </Col>
                                            <Col maxwidth="200px" sm="3" xs="6">
                                                <FormGroup label="Hora">
                                                    <Input
                                                        disabled={ disabled }
                                                        error={ errors.time }
                                                        type="time"
                                                        width="100px"
                                                        { ...timeInput }
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col sm="3" xs="6">
                                                <FormGroup label="Duración (mins)">
                                                    <Input
                                                        error={ !!errors.duration }
                                                        margin="0px"
                                                        width="150px"
                                                        { ...durationInput }
                                                    />
                                                    <ErrorMessage error={ errors.duration } />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Fragment>
                                    : <Row>
                                        <Col xs="12">
                                            <FormGroup label="Expositor">
                                                <Message>
                                                    { speakerName }
                                                </Message>
                                            </FormGroup>
                                        </Col>
                                        <Col xs="12">
                                            <FormGroup label="Fecha">
                                                <Message>
                                                    { `${ objectToDate(date).format('DD/MM/YYYY') } ${ time }${ duration ? ` - ${ duration } mins` : '' }` }
                                                </Message>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                            }
                            <Row>
                                <Col xs="12">
                                    <FormGroup label="Descripción">
                                        <Input
                                            disabled={ disabled }
                                            error={ !!errors.comment }
                                            height="150px"
                                            type="area"
                                            { ...commentInput }
                                        />
                                        <ErrorMessage error={ errors.comment } relative={ true } />
                                    </FormGroup>
                                </Col>
                                <Col xs="12">
                                    <Checkbox
                                        disabled={ disabled }
                                        label="Permitir unirse sin registrarse"
                                        margin="5px 0px"
                                        { ...publicCheck }
                                    />
                                </Col>
                                <Col xs="12">
                                    <Checkbox
                                        disabled={ disabled }
                                        label="Permitir escribir en el chat sólo a usuarios registrados"
                                        margin="5px 0px"
                                        { ...chatCheck }
                                    />
                                </Col>
                            </Row>
                            <ConfirmFooter
                                cancelModalText="¿Desea eliminar la videoconferencia?"
                                cancelText="Eliminar"
                                confirmModal={ mode !== 'ver' }
                                confirmModalText={ `¿Desea ${ mode } la videoconferencia?` }
                                confirmText={ mode === 'ver' ? 'Volver' : 'Confirmar' }
                                disabled={ ['creating', 'deleting', 'editing'].includes(status) }
                                onBeforeConfirm={ mode === 'ver' ? undefined : validate }
                                onCancel={ mode === 'editar' ? handleDelete : undefined }
                                onConfirm={ handleConfirm }
                            />
                        </Fragment>
            }
        </FormLayout>
    );
};

VideoconferenceRegistration.propTypes = {
    createVideoconference: PropTypes.func,
    deleteVideoconference: PropTypes.func,
    editVideoconference: PropTypes.func,
    getVideoconference: PropTypes.func,
    history: PropTypes.object,
    location: PropTypes.object,
    setVideoconferenceVideoconference: PropTypes.func,
    status: PropTypes.string,
    user: PropTypes.object,
    videoconference: PropTypes.object
};

export default withRouter(VideoconferenceRegistration);
